import React from 'react';

import ErrorBoundary from 'app/widgets/ErrorBoundary';

import LiveContainer from './Container';
import LiveFavoritesMenuLayer from './layers/Favorites';
import LiveSportTournamentsMenuLayer from './layers/SportTournaments';
import LiveStagesAndMatchesMenuLayer from './layers/StagesAndMatches';
import LiveRootMenu from './RootMenu';

const LiveMenu: React.FC = () => {
  return (
    <LiveContainer>
      <ErrorBoundary>
        <LiveRootMenu />
      </ErrorBoundary>

      <ErrorBoundary>
        <LiveSportTournamentsMenuLayer />
        <LiveStagesAndMatchesMenuLayer />
        <LiveFavoritesMenuLayer />
      </ErrorBoundary>
    </LiveContainer>
  );
};

export default LiveMenu;
